export const ROOT = 'freeExtracharge';

export const FETCH_FREE_EXTRACHARGE_REQUEST = `${ROOT}/FETCH_FREE_EXTRACHARGE_REQUEST`;
export const FETCH_FREE_EXTRACHARGE_FAILURE = `${ROOT}/FETCH_FREE_EXTRACHARGE_FAILURE`;
export const FETCH_FREE_EXTRACHARGE_SUCCESS = `${ROOT}/FETCH_FREE_EXTRACHARGE_SUCCESS`;
